import React from 'react';
import { Card, Spin, Typography, Space } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface PaymentProgressProps {
  onayId: string;
  amount?: number;
}

const PaymentProgress: React.FC<PaymentProgressProps> = ({ onayId, amount }) => {
  return (
    <Card
      style={{
        width: '100%',
        maxWidth: 500,
        textAlign: 'center',
        padding: '24px',
      }}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
          size="large"
        />

        <div>
          <Title level={3} style={{ marginBottom: 8 }}>
            Обработка платежа
          </Title>
          <Text type="secondary">
            Пожалуйста, подождите, пока мы обработаем ваш платеж...
          </Text>
        </div>

        <div style={{
          background: '#f5f5f5',
          padding: '16px',
          borderRadius: '8px',
          marginTop: '16px'
        }}>
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div>
              <Text type="secondary">Аккаунт:</Text>
              <br />
              <Text strong>{onayId}</Text>
            </div>
            {amount !== undefined && amount > 0 && (
              <div>
                <Text type="secondary">Сумма:</Text>
                <br />
                <Text strong style={{ fontSize: '18px' }}>{amount} ₸</Text>
              </div>
            )}
          </Space>
        </div>
      </Space>
    </Card>
  );
};

export default PaymentProgress;
